// 舆情分析
export default {
  wuquanxiancaozuo: '无权限操作',
  baocun: '保存',
  qingxuanze: '请选择',
  shijiandian: '时间点',
  xuanzeshijian: '请选择推送时间',
  shanchu: '删除',
  bunengweikong: '内容不能为空',
}